module.exports = __webpack_public_path__ + "img/shed-icon.5bfc235d.png";